/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Cookies from 'universal-cookie';
import {Panel, Button, HelpBlock} from 'eui-components';

import classnames from './LoginView.css';

class LoginView extends Component {
  /**
   * Cookie name used to store the name of the user's previous authenticating institution name.
   */
  static AUTHENTICATING_INSTITUTION_NAME_COOKIE = 'servConfigAuthInstName';

  /**
   * Cookie name used to store the name of the user's previous authenticating institution id.
   */
  static AUTHENTICATING_INSTITUTION_REGISTRY_ID_COOKIE = 'servConfigAuthRegId';

  static AUTHENTICATION_COOKIES = [
      LoginView.AUTHENTICATING_INSTITUTION_NAME_COOKIE,
      LoginView.AUTHENTICATING_INSTITUTION_REGISTRY_ID_COOKIE
  ];

  constructor (props) {
    super(props);
    this.cookies = new Cookies();
    this.state = {
      currentYear: new Date().getFullYear()
    };
  }

  render () {
    const cookieInstName = this.cookies.get(LoginView.AUTHENTICATING_INSTITUTION_NAME_COOKIE);
    const cookieInstNameDisplay = decodeURIComponent((cookieInstName + '').replace(/\+/g, '%20'));

    return (
      <div className={classnames.flexcontainer}>
        <div className={classnames.content}>
          <div className={classnames.bd + ' container'}>
            <Panel style={{maxWidth: 500, margin: '0 auto 10px'}}>
              <Panel.Heading>
                <Panel.Title>
                  <FormattedMessage id="LoginView.header" defaultMessage="Sign in to Service Configuration" />
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <Button block onClick={this.loginUsingWorldCatDotOrg} id='loginview-ldap-signin-btn'>
                  <FormattedMessage id="LoginView.eldapAuthentication"
                    defaultMessage="Use Your WorldCat Account"/>
                </Button>
                {/* NOTE: We use a <div /> so that the child link recieves click events in FireFox. */}
                <div className="btn btn-default btn-block" >
                  <Button block bsStyle="link" onClick={this.loginUsingEidm} id='loginview-idm-signin-btn'              >
                    <FormattedMessage id="LoginView.oclcServicesAuthentication"
                      defaultMessage="Use Your OCLC Services Account"/>
                    <HelpBlock>
                      {cookieInstName
                        ? (`[${cookieInstNameDisplay}]`)
                        : <FormattedMessage id="LoginView.worldShareBriefText"
                          defaultMessage="WorldShare users affiliated with an institution"/>}
                    </HelpBlock>
                  </Button>
                  {cookieInstName
                    ? <Button bsStyle="link" onClick={this.clearInstitutionCookie} id='loginview-clear-cookie-link' className={classnames.clearCookieLink}>
                      <FormattedMessage id="LoginView.selectDifferentInstitution"
                        defaultMessage="Select a different WorldShare institution"/>
                    </Button>
                    : ''
                  }
                </div>
              </Panel.Body>
            </Panel>
          </div>
        </div>
        <div className={classnames.copyright}>
          <FormattedMessage id="LoginView.copyrightText"
            defaultMessage={`© {currentYear} OCLC. Domestic and international trademarks and/or service marks of OCLC, Inc. and its affiliates.`}
            values={{
              currentYear: this.state.currentYear}}
          />
        </div>
      </div>
    );
  }

  /**
   * Event handler when user selects to clear their institution cookie from a previous authentication.
   *
   * @param e onClick event.
   */
  clearInstitutionCookie = (e) => {
    // don't let the event propagate to the parent div, which will forward
    // the user to EIDM.  We must remove the cookies, then send the user to EIDM.  Calling
    // e.stopPropagation() prevents race conditions.
    e.stopPropagation();
    e.preventDefault();

    const path = `${process.env.PUBLIC_URL}` || '/';
    LoginView.AUTHENTICATION_COOKIES.forEach(cookie => {
      this.cookies.remove(cookie, {path: path});
      if (path !== '/') {
        this.cookies.remove(cookie, {path: path + '/'});
      }
    });
    this.loginUsingEidm();
  };

  /**
   * Event handler that sends the user through ELDAP authentication.
   */
  loginUsingWorldCatDotOrg = () => {
    window.location.assign(`${window.location.origin}${process.env.PUBLIC_URL}/main/eldap`);
  };

  /**
   * Event handler that sends the user through EIDM authentication.
   */
  loginUsingEidm = () => {
    window.location.assign(`${window.location.origin}${process.env.PUBLIC_URL}/main/eidm`);
  };
}

export default injectIntl(LoginView);



// WEBPACK FOOTER //
// ./src/LoginView/LoginView.js